import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} tomos premium`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} bonos estratégicos`
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="bg-stage-deep energy-glow tech-grid relative isolate overflow-hidden" data-id="element-103" data-mp="sb1efy4p8fa9">
      <div className="energy-bar h-2 w-full" aria-hidden="true" data-id="element-104" data-mp="ncgjoe87unt7" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-12 text-center lg:pb-20 lg:pt-16" data-id="element-105" data-mp="neaugzprwzjk">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-md border border-green/50 bg-green/15 px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-greenGlow" data-id="element-106" data-mp="3d2tqpg8vwwhp">
          <ZapIcon className="h-4 w-4" aria-hidden="true" data-id="element-107" data-mp="39autvl4lu10x" /> Mega Pack Energías Renovables Listo
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.05] text-white sm:text-5xl lg:text-6xl" data-id="element-108" data-mp="3e8eh3aja5o50">
          Todo tu año de Energías Renovables
          <br data-id="element-109" data-mp="2viokchvyisag" />
          <span className="text-yellow" data-id="element-110" data-mp="2vi54r7ts4fzl">resuelto en una tarde.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-9 max-w-3xl" data-id="element-111" data-mp="2hinawe1mmcjd">
          <img src={productImage} alt="Mega Pack Energías Renovables Listo: nueve tomos y cinco bonos con paneles solares, aerogeneradores y equipos de medición" className="mx-auto w-full rounded-xl drop-shadow-[0_24px_44px_rgba(2,10,25,.6)]" data-id="element-112" data-mp="s3cki77jpdoz" />
        </motion.div>

        <div className="mt-9" data-id="element-113" data-mp="db2ede3uydmq">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-114" data-mp="1b0nmw0oh4n8n">
            Quiero mi Mega Pack ahora
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-onDark" data-id="element-115" data-mp="162m0p6vr47sy">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-md border border-steel bg-navy/70 px-3 py-2" data-id="element-116" data-mp="x1nvil9ktu8s">
              <Icon className="h-3.5 w-3.5 text-greenGlow" aria-hidden="true" data-id="element-117" data-mp="3lqm3c0xhx9vz" />
              {label}
            </li>)}
        </ul>

        <p className="mt-6 text-xs font-semibold uppercase tracking-[.14em] text-mutedDark" data-id="element-118" data-mp="1xa44lgt9woko">
          Para docentes de Latinoamérica · Actualizado 2026
        </p>
      </div>
    </section>;
}